import $ from 'jquery'
import { MessageOverlay } from './message-overlay'
import { extractMessageFromAjaxFailure } from './ajax-error'

const debug = require('debug')('pm:settings')

const Settings = {
  init: function () {
    $('#label-selector').on('change', function () {
      const label = $('.nav span')
      const current = label.attr('class')

      label.removeClass(current).addClass('label-' + $(this).val())
    })

    $('#cc-option input:eq(0)').on('click', function () {
      $('#new-cc').hideMe()
    })

    $('#cc-option input:eq(1)').on('click', function () {
      $('#new-cc').showMe()
    })

    Settings.renewOptions()
    Settings.watchCheckInboundWebhook()
    Settings.spamThreshold()
    Settings.domainRulesSubmit()
    Settings.enableDeleteDomainRule()
    Settings.serverLookup()
    Settings.disableUnsubWarning()

    // Link tracking
    Settings.setLinkTrackingOptions()
    $(document).on(
      'change',
      '.js-link-track input[type="checkbox"]',
      Settings.linkTrackOptionChange
    )
  },

  serverLookup: function () {
    $('.js-server-token-lookup').on(
      'autocomplete:selected',
      function (event, item) {
        $('.js-server-token-form').attr('action', item.credentials_url)
        $('.js-server-keys').removeAttr('disabled').removeClass('is-disabled')

        $(this).data('selected-item', item.name)
      }
    )

    $('.js-server-token-lookup').on('keyup', function () {
      // Disable the button if the current value doesn't match the last selected item.
      if ($(this).val() !== $(this).data('selected-item')) {
        $('.js-server-token-form').attr('action', '#')
        $('.js-server-keys').attr('disabled', true).addClass('is-disabled')
      }
    })
  },

  renewOptions: function () {
    if ($('#renew-options').length === 0) {
      return
    }

    $('#renew-options .c-form-row:eq(0) input[type=radio]').on(
      'click',
      function () {
        $('#renew-options .c-form-row:eq(0) .c-form-row_text').showMe()
      }
    )

    $('#renew-options .c-form-row:eq(1) input[type=radio]').on(
      'click',
      function () {
        $('#renew-options .c-form-row:eq(0) .c-form-row_text').hideMe()
      }
    )

    if (
      $('#renew-options .c-form-row:eq(0) input[type=radio]').get(0).checked
    ) {
      $('#renew-options .c-form-row:eq(0) .c-form-row_text').showMe()
    } else {
      $('#renew-options .c-form-row:eq(0) .c-form-row_text').hideMe()
    }
  },

  watchCheckInboundWebhook: function () {
    const $checkButton = $('.js-check-inbound-webhook')
    const $input = $checkButton.prev('input')
    const $parent = $checkButton.parents('.c-form-row')
    const $includeRawEmailCheckbox = $checkButton
      .parents('form')
      .find('.js-include-raw-email-for-inbound')
    const $controlls = $input.add($includeRawEmailCheckbox)

    const testUrl = $checkButton.attr('href')

    $input.on('keyup', function () {
      if ($input.val().trim() !== '') {
        $checkButton.showMe()
      } else {
        $checkButton.hideMe()
      }
    })

    $checkButton.on('click', function (event) {
      event.preventDefault()

      $checkButton.addClass('is-loading')
      $controlls.prop('disabled', true)

      $parent
        .removeClass('error')
        .find('.c-form-row_error, .c-form-row_text')
        .remove()

      const payload = {
        webhook: {
          url: $input.val(),
          triggers_attributes: {
            Inbound: {
              Enabled: true,
              IncludeRawEmail: $includeRawEmailCheckbox.is(':checked'),
            },
          },
        },
      }

      $.post(testUrl, payload)
        .done(function (response) {
          if (response.success) {
            $(
              '<div class="c-form-row_text"><p class="icon-success success-label">' +
                response.message +
                '</p></div>'
            ).appendTo($parent)
          } else {
            $parent.addClass('error')
            $(
              '<div class="c-form-row_error"><p>' +
                response.message +
                '</p></div>'
            ).appendTo($parent)
          }
        })
        .fail(function () {
          MessageOverlay.show(
            'Uh oh. Something went wrong. Try testing your Webhook URL again.',
            'error'
          )
        })
        .always(function () {
          $checkButton.removeClass('is-loading')
          $controlls.prop('disabled', false)
        })
    })
  },

  spamThreshold: function () {
    $('.js-slider').rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider rangeslider--intensity',
      showMarkers: true,
      allowOffStep: true,
      steps: 1,
      onSlide: function (position, value, min, max) {
        const label = $('.js-slider-value')

        // Update value label
        if (value === min) {
          label.val('off')
          label.css({ color: '#999' })
        } else {
          // Select color based off range
          const colors = ['#74AB16', '#E6C435', '#F19340', '#DE573C', '#CC2C30']
          const minOffset = min + 1

          let remainder = Math.floor(
            (value - minOffset) / ((max - minOffset) / colors.length)
          )

          if (remainder === colors.length) {
            remainder = remainder - 1
          }

          label.val(value)
          label.css({ color: colors[remainder] })
        }
      },
    })
  },

  domainRulesSubmit: function () {
    $('form.domain-rules').on('submit', function (event) {
      event.preventDefault()
      Settings.addDomainRule()
      $(this)
        .addClass('u-is-loading')
        .find('input[type="submit"]')
        .prop('disabled', true)
    })
  },

  enableDeleteDomainRule: function () {
    $('.domain-rules-list').on('click', '.u-btn-delete', function (event) {
      event.preventDefault()
      $(this).addClass('u-is-loading u-is-loading--small')
      Settings.deleteDomainRule(this)
    })
  },

  addDomainRule: function () {
    const form = $('form.domain-rules'),
      submitBtn = $(form).find('input[type=submit]'),
      domainList = $('.domain-rules-list')

    // POST request to form action
    $.ajax({
      url: form.attr('action'),
      data: form.serialize(),
      type: 'POST',
      dataType: 'html',
      success: function (response) {
        $(form).resetFormInputs()
        Settings.removeDomainValidationError()
        domainList.append(response)
        domainList.toggleEmptyTable()
      },
      error: function (response) {
        Settings.showDomainValidationErrors(response.responseText)
        submitBtn.prop('disabled', false)
      },
      complete: function () {
        form.removeClass('u-is-loading')
        submitBtn.prop('disabled', true)
      },
    })
  },

  deleteDomainRule: function (item) {
    const row = $(item).parents('tr')

    // DELETE request to link href
    $.ajax({
      url: $(item).attr('href'),
      type: 'DELETE',
      success: function () {
        row.fadeOut(500, function () {
          row.remove()
          $('.domain-rules-list').toggleEmptyTable()
        })
      },
      error: function () {
        $(item).removeClass('u-btn-delete--loading')
      },
    })
  },

  showDomainValidationErrors: function (message) {
    const form = $('form.domain-rules'),
      formError = form.find('.c-form-row_error')

    // Check if form error is already active
    if (formError.length > 0) {
      // Insert new message into existing error
      formError.find('p').html(message)
    } else {
      // Insert elemenet with message
      form.addClass('error')
      $(
        '<div class="c-form-row_error c-form-row_error--stacked"><p>' +
          message +
          '</p></div>'
      ).appendTo(form)
    }
  },

  removeDomainValidationError: function () {
    const form = $('form.domain-rules')

    // Remove error class and DOM element
    form.removeClass('error')
    form.find('.c-form-row_error').remove()
  },

  setLinkTrackingOptions: function () {
    // Sets the proper link tracking toggle states when the page loads
    const $el = $('.js-link-track')
    const current = $el.data('current-setting')

    // Check if link tracking is enabled
    if (current !== 'None') {
      // Enable main toggle and option container
      $el.find('.js-toggle-link-track').prop('checked', true)
      $el.find('.js-link-track-options').fadeIn()

      // Link tracking option checkboxes
      const $htmlToggle = $('.js-toggle-link-html')
      const $textToggle = $('.js-toggle-link-text')

      if (current === 'HtmlOnly') {
        $htmlToggle.prop('checked', true)
      } else if (current === 'TextOnly') {
        $textToggle.prop('checked', true)
      } else if (current === 'HtmlAndText') {
        $textToggle.add($htmlToggle).prop('checked', true)
      }
    }
  },

  linkTrackOptionChange: function () {
    // When a link tracking option is changed by the user
    const $el = $('.js-link-track')

    // Toggles
    const $trackToggle = $('.js-toggle-link-track')
    const $htmlToggle = $('.js-toggle-link-html')
    const $textToggle = $('.js-toggle-link-text')

    // If the main tracking toggle was just enabled
    // TODO: Is there a way around this hairy conditional?
    if ($(this).is($trackToggle) && $(this).is(':checked')) {
      // Check both options and show link track options
      $htmlToggle.add($textToggle).prop('checked', true)
      $('.js-link-track-options').fadeIn(150)

      Settings.linkTrackOptionChangeRequest($el, $(this), 'HtmlAndText')
    } else if ($(this).is($trackToggle) && !$(this).is(':checked')) {
      // If main toggle was turned off
      Settings.linkTrackOptionChangeRequest($el, $(this), 'None')

      // Hide options and uncheck boxes
      $('.js-link-track-options').fadeOut(150, function () {
        $(this).checkboxProps(false)
      })
    } else {
      // Main toggle wasn't changed so get the current state of checkboxes

      if ($htmlToggle.is(':checked') && $textToggle.is(':checked')) {
        // Both options are checked
        Settings.linkTrackOptionChangeRequest($el, $(this), 'HtmlAndText')
      } else if (!$htmlToggle.is(':checked') && !$textToggle.is(':checked')) {
        // Both options are off, disable main toggle
        $trackToggle.prop('checked', false)
        Settings.linkTrackOptionChangeRequest($el, $(this), 'None')

        $('.js-link-track-options').fadeOut(150)
      } else if ($htmlToggle.is(':checked')) {
        // HTML only
        Settings.linkTrackOptionChangeRequest($el, $(this), 'HtmlOnly')
      } else if ($textToggle.is(':checked')) {
        // Text only
        Settings.linkTrackOptionChangeRequest($el, $(this), 'TextOnly')
      }
    }
  },

  linkTrackOptionChangeRequest: function ($el, $target, newValue) {
    const url = $el.data('update-uri')
    debug('linkTrackingOptionChange', { url, newValue })

    $.ajax({
      url,
      method: 'PATCH',
      data: { server: { track_links: newValue } },
      dataType: 'json',
    })
      .done(function () {
        // Show success message
        const state = $target.prop('checked') ? 'enabled' : 'disabled'
        MessageOverlay.show(
          $target.data('message-prefix') + ' is now ' + state + '.'
        )
      })
      .fail(function (jqXHR) {
        // Switch back to previous state
        $target.prop('checked', !$target.is(':checked'))
        MessageOverlay.show(
          extractMessageFromAjaxFailure(
            jqXHR,
            'There was a problem saving your change. Please try again.'
          ),
          'error'
        )

        // TODO: need to re-toggle checkbox options if main toggle or last track option was disabled
      })
  },

  disableUnsubWarning: function () {
    $('.js-unsub-management').on('change', function () {
      const $warning = $('.js-disable-unsub-warning')
      const show = $(this).val() === 'Custom'
      if (show) {
        $warning.slideDown(250)
      } else {
        $warning.slideUp(250)
      }
    })
  },
}

$(Settings.init)
